import { render, staticRenderFns } from "./distributor_edit.vue?vue&type=template&id=2ed99b94"
import script from "./distributor_edit.vue?vue&type=script&lang=js"
export * from "./distributor_edit.vue?vue&type=script&lang=js"
import style0 from "./distributor_edit.vue?vue&type=style&index=0&id=2ed99b94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports